import { Timezones } from './timezone';
export function getTimezoneId() {
    if (window.Intl) {
        const result = Intl.DateTimeFormat().resolvedOptions().timeZone;
        // IE下不生效
        if (result) {
            return result;
        }
    }
    const offset = new Date().getTimezoneOffset();
    let id = '';
    for (let i = 0, len = Timezones.length; i < len; i++) {
        const item = Timezones[i];
        const [hour, min] = item.utc_offset.split(':');
        if (Number(hour) * 60 + Number(min) + offset === 0) {
            id = item.value;
            break;
        }
    }
    return id;
}
// 辅助函数，判断是否是闰年
export function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}
